var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 4.6875H5.46875C5.0375 4.6875 4.6875 5.0375 4.6875 5.46875C4.6875 5.9 5.0375 6.25 5.46875 6.25H14.8438C15.275 6.25 15.625 5.9 15.625 5.46875C15.625 5.0375 15.275 4.6875 14.8438 4.6875Z",
    fill: "#424242",
    stroke: "#424242",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 7.8125H5.46875C5.0375 7.8125 4.6875 8.1625 4.6875 8.59375C4.6875 9.025 5.0375 9.375 5.46875 9.375H11.7188C12.15 9.375 12.5 9.025 12.5 8.59375C12.5 8.1625 12.15 7.8125 11.7188 7.8125Z",
    fill: "#424242",
    stroke: "#424242",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3547 1.04517H4.04469C2.41348 1.04517 1.08691 2.37173 1.08691 4.00294V18.7918C1.08691 19.0787 1.25255 19.3405 1.51283 19.4618C1.61192 19.5076 1.71988 19.5313 1.82636 19.5313C1.99643 19.5313 2.16502 19.4721 2.2996 19.3597L6.5307 15.834H17.3547C18.9859 15.834 20.3125 14.5075 20.3125 12.8763V4.00294C20.3125 2.37173 18.9859 1.04517 17.3547 1.04517ZM18.8336 12.8763C18.8336 13.6911 18.171 14.3552 17.3547 14.3552H6.26302C6.08999 14.3552 5.92288 14.4158 5.78978 14.5267L2.5658 17.2138V4.00294C2.5658 3.18807 3.22834 2.52405 4.04469 2.52405H17.3547C18.171 2.52405 18.8336 3.18807 18.8336 4.00294V12.8763Z",
    fill: "#424242",
    stroke: "#424242",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2083 5C19.8231 5 19.5104 5.31267 19.5104 5.69792C19.5104 6.08317 19.8231 6.39583 20.2083 6.39583C20.9788 6.39583 21.6042 7.02256 21.6042 7.79167V19.599L19.248 17.7146C19.1252 17.6169 18.9702 17.5625 18.8125 17.5625H9.04167C8.27117 17.5625 7.64583 16.9358 7.64583 16.1667V15.4688C7.64583 15.0835 7.33317 14.7708 6.94792 14.7708C6.56267 14.7708 6.25 15.0835 6.25 15.4688V16.1667C6.25 17.7063 7.50206 18.9583 9.04167 18.9583H18.5668L21.8652 21.5979C21.9922 21.6984 22.1471 21.75 22.3021 21.75C22.404 21.75 22.5073 21.7277 22.605 21.6816C22.8465 21.5644 23 21.3201 23 21.0521V7.79167C23 6.25206 21.7479 5 20.2083 5Z",
    fill: "#424242",
    stroke: "#424242",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.488e6075.svg";
export { ForwardRef as ReactComponent };